import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "@/pages/Login";
import { Prospects } from "@/pages/Prospects";
import { ProspectDetail } from "@/pages/ProspectDetail";
import { Privacy } from "@/pages/Privacy";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";

export default function App() {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/login" element={<Login />} />
      <Route path="/privacy" element={<Privacy />} />

      {/* Routes protégées */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/prospects" replace />} />
        <Route path="/prospects" element={<Prospects />} />
        <Route path="/prospects/:id" element={<ProspectDetail />} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/prospects" replace />} />
    </Routes>
  );
}
